<template>
    <CardBase title="Estadísticas Generales" :loading="loading">
        <template #extra-data >
            <DateRangePicker
                @change="onDateRangeChange"
            />
        </template>
        <GChart
            v-if="hayDatos && !loading"
            type="ColumnChart"
            :key="chartKey"
            :data="chartData"
            :options="chartOptions"
            :style="{ height: '500px' }"
        />
        <div v-else-if="!loading" class="alert alert-warning text-center my-4">
            No hay datos disponibles para el período seleccionado
        </div>
    </CardBase>
</template>

<script>
    import CardBase from '@/components/backend/campana-emails/dashboard/common/CardBase';
    import DateRangePicker  from '@/components/backend/campana-emails/dashboard/common/DateRangePicker';
    import { GChart } from 'vue-google-charts';

    export default {
        components: {
            CardBase,
            DateRangePicker,
            GChart
        },
        props:{
            datosEstadisticas: {
                type: Object,
                default: () => ({})
            },
            loading: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                stats: [
                    { key: 'enviados', label: 'Emails enviados', variant: 'primary', color: '#003049' },
                    { key: 'delivered', label: 'Entregados', variant: 'success', color: '#2a9d8f' },
                    { key: 'opens', label: 'Visualizaciones', variant: 'info', color: '#f4a261' },
                    { key: 'clicks', label: 'Clics', variant: 'secondary', color: '#457b9d' }
                ]
            };
        },

        methods: {
            onDateRangeChange({ startDate, endDate }) {
                this.$emit('date-range-changed', { startDate, endDate });
            }
        },
        computed: {
            hayDatos() {
                if (!this.datosEstadisticas.data) return false;
                return Object.keys(this.datosEstadisticas.data).length > 0;
            },

            chartKey() {
                return JSON.stringify(this.datosEstadisticas);
            },
            
            chartData() {
                const headers = [
                    "Fecha",
                    "Emails enviados",
                    "Entregados",
                    "Visualizaciones",
                    "Clics",
                ];

                if (!this.datosEstadisticas.data) {
                    return [headers];
                }

                const rows = Object.entries(this.datosEstadisticas.data)
                    .sort((a, b) => new Date(a[0]) - new Date(b[0]))
                    .map(([fecha, stats]) => {
                        const enviados =
                            (stats.delivered || 0) +
                            (stats.bounces || 0) +
                            (stats.failures || 0);
                        return [
                            fecha,
                            enviados,
                            stats.delivered || 0,
                            stats.opens || 0,
                            stats.clicks || 0,
                        ];
                    });

                return [headers, ...rows];
            },

            chartOptions() {
                return {
                    height: 500,
                    chartArea: { width: '90%', height: '65%' },
                    hAxis: {
                        slantedText: true,
                        slantedTextAngle: 45,
                        textStyle: { fontSize: 12 },
                        format: 'dd/MM/yy'
                    },
                    vAxis: {
                        minValue: 0,
                        format: '#,###',
                        
                    },
                    colors: this.stats.map(stat => stat.color),
                    legend: { position: "top" },
                    bar: { groupWidth: "40%" },
                    animation: {
                        duration: 1000,
                        easing: 'out',
                        startup: true
                    }, 
                    tooltip: { 
                        isHtml: true,
                        trigger: 'focus',
                        showColorCode: true,
                        textStyle: { 
                            fontSize: 14
                        }
                    },
                    focusTarget: 'category' 
                };
            }
        }
    }
</script>
<style>
.display-4 {
    font-size: 2.5rem;
    font-weight: 300;
}

.google-visualization-tooltip {
    width: 18% !important;
}

@media (max-width: 575px) {
    .google-visualization-tooltip {
        width: 75% !important;
        height: 40% !important;
    }
}

@media (max-width: 1280px) and (min-width: 768px) {
    .google-visualization-tooltip {
        width: 32.5% !important;
    }

}


@media (max-width: 767.98px) {
    .display-4 {
        font-size: 1.8rem;
    }

}
</style>

